import { OrderSide } from "../../ws/types";
import "../../styles/order/OrderFilters.scss";

type FilterType = OrderSide | "all" | "my";
interface Props {
    filter: FilterType;
    jettonFilter: string;
    paymentMethodFilter: string;
    onFilterChange: (filter: FilterType) => void;
    onJettonFilterChange: (jetton: string) => void;
    onPaymentMethodFilterChange: (method: string) => void;
}

const JETTON_FILTERS = [
    { value: "all", label: "Все токены" },
    { value: "TON", label: "TON" },
    { value: "TMC", label: "TMC" },
    { value: "USDT", label: "USDT" },
    { value: "ODDB", label: "ODDB" },
    { value: "other", label: "Другие" }
];

const PAYMENT_METHOD_FILTERS = [
    { value: "all", label: "Все методы" },
    { value: "Sber", label: "Сбербанк" },
    { value: "Tinkoff", label: "Тинькофф" },
    { value: "Raiffeisen", label: "Райффайзен" },
    { value: "Alpha", label: "Альфа-Банк" },
    { value: "Ozon", label: "Озон Банк" },
    { value: "SBP", label: "СБП" }
];

const ACTIVE_FILTER_COLOR = "#483d8b"; // Значительно темнее оттенок для активного фильтра

export default function OrderFilters({
    filter,
    jettonFilter,
    paymentMethodFilter,
    onFilterChange,
    onJettonFilterChange,
    onPaymentMethodFilterChange
}: Props) {
    const handleClearFilters = () => {
        onJettonFilterChange("all");
        onPaymentMethodFilterChange("all");
    };

    return (
        <>
            <div className="filters-row">
                <div className="filters">
                    <button 
                        className={`filter-btn${filter === "all" ? " active" : ""}`}
                        onClick={() => onFilterChange("all")}
                    >
                        Все
                    </button>
                    <button 
                        className={`filter-btn${filter === "buy" ? " active" : ""}`}
                        onClick={() => onFilterChange("buy")}
                    >
                        Покупка
                    </button>
                    <button 
                        className={`filter-btn${filter === "sell" ? " active" : ""}`}
                        onClick={() => onFilterChange("sell")}
                    >
                        Продажа
                    </button>
                    <button 
                        className={`filter-btn${filter === "my" ? " active" : ""}`}
                        onClick={() => onFilterChange("my")}
                    >
                        Мои
                    </button>
                </div>
            </div>

            <div className="advanced-filters">
                <div className="filter-group">
                    <label htmlFor="jetton-filter-select">Токен:</label>
                    <select 
                        id="jetton-filter-select"
                        value={jettonFilter} 
                        onChange={(e) => onJettonFilterChange(e.target.value)}
                        className="filter-select"
                    >
                        {JETTON_FILTERS.map(jf => (
                            <option key={jf.value} value={jf.value}>{jf.label}</option>
                        ))}
                    </select>
                </div>
                <div className="filter-group">
                    <label htmlFor="payment-method-filter-select">Платежный метод:</label>
                    <select 
                        id="payment-method-filter-select"
                        value={paymentMethodFilter} 
                        onChange={(e) => onPaymentMethodFilterChange(e.target.value)}
                        className="filter-select"
                    >
                        {PAYMENT_METHOD_FILTERS.map(pm => (
                            <option key={pm.value} value={pm.value}>{pm.label}</option>
                        ))}
                    </select>
                </div>
                {(jettonFilter !== "all" || paymentMethodFilter !== "all") && (
                    <button 
                        className="clear-filters-btn"
                        onClick={handleClearFilters}
                    >
                        ✕ Сбросить фильтры
                    </button>
                )}
            </div>
        </>
    );
}
